import React, { createContext, useContext, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

// Create context
const SnackbarContext = createContext({
  showSnackbar: () => {},
  hideSnackbar: () => {},
});

// Custom hook to use the snackbar context
export const useSnackbar = () => useContext(SnackbarContext);

export const SnackbarProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('info'); // 'error', 'warning', 'info', 'success'
  const [duration, setDuration] = useState(6000);
  const [position, setPosition] = useState({
    vertical: 'bottom',
    horizontal: 'left',
  });

  // Show snackbar with custom message and options
  const showSnackbar = (
    msg, 
    options = { 
      severity: 'info', 
      duration: 6000,
      position: { vertical: 'bottom', horizontal: 'left' }
    }
  ) => {
    setMessage(msg);
    setSeverity(options.severity || 'info');
    setDuration(options.duration || 6000);
    if (options.position) {
      setPosition(options.position);
    }
    setOpen(true);
  };

  // Hide snackbar
  const hideSnackbar = () => {
    setOpen(false);
  };

  // Handle close event
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    hideSnackbar();
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar, hideSnackbar }}>
      {children}
      <Snackbar 
        open={open} 
        autoHideDuration={duration} 
        onClose={handleClose}
        anchorOrigin={position}
      >
        <Alert 
          onClose={handleClose} 
          severity={severity} 
          sx={{ width: '100%' }}
          variant="filled"
          elevation={6}
        >
          {message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};

export default SnackbarProvider;
